// stores/global.ts
import { defineStore } from 'pinia'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    isSidebarMinimized: false,
    language: localStorage.getItem('language') || 'gb',
    theme: localStorage.getItem('theme') || 'light', // new: load theme
  }),

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },
    setLanguage(code: string) {
      this.language = code
      localStorage.setItem('language', code)
    },
    setTheme(name: string) {
      this.theme = name
      localStorage.setItem('theme', name)
    },
  },
})
